import { Component, OnInit, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, FormControl, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as UserDataConfig from '../../config/user-data.config';
import { CommonUtilityService, FormValidationsService, QuoteDataCaptureService, AnnuitantDetailService, LoaderService, ButtonService, CURRENT_ENVIROMENT, SERVICE_END_POINT, UtilService, ApplicationDataCaptureService, AnalyticsService } from 'src/app/shared';
import { CMSResolver } from '../../../../core/resolvers/cms.resolver';
import { CmsService } from '../../../../core/cms/service.service'
import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { RegistrationDetails } from '../../../../model/ngrx/registration-details.model';
import { PersonalDetails } from '../../../../model/ngrx/personal-details.model';
import * as PersDetailsActions from '../../../../store/actions/personal-details.actions';
import * as RegsDetailsActions from '../../../../store/actions/registration-details.actions';
import { AlertModal } from 'src/app/model/alert';
import { Location } from '@angular/common';
import { EmailMatch } from 'src/app/shared/validators/email-match.validators';
import * as loggedInDetailActions from '../../../../store/actions/loggedin-detail.action';
import { CardRefresh } from 'src/app/model/ngrx/card-refresh.model';
import * as CardRefreshActions from '../../../../store/actions/card-refresh.actions';
// import { setTimeout } from 'timers';
//import { AbstractControl } from '@angular/forms/src/model';
import { filter } from 'rxjs/internal/operators/filter';
// import { UtilService } from '../../../../shared';
import * as commonUserDataConfig from '../../../../common-components/config/user-data.config';
import { ATTRIBUTE_NAMES_CONST } from 'src/app/shared/services/api-constants/attribute-names-constant';
import { SyncService } from 'src/app/pages/medical-underwriting';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { RefNo } from 'src/app/model/ngrx/reference-number.model';
import { DeviceDimensionsService } from 'src/app/shared/utilities/functionality/device-dimensions.service';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';


@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})


export class RegistrationComponent implements OnInit, OnDestroy {


  enableOtherTitle: boolean = false;
  editMode: boolean;
  addressFlag: boolean = false;
  public ageValidatorFlag = false;
  public alertModalConfig: AlertModal;
  public ageAlertModalConfig: AlertModal = new AlertModal('alert', "You're outside the age range we typically deal with", '', 'Proceed', '', '');
  displayAlert: boolean = false;
  overseasCustomer: boolean;
  public ukAddressAlertModalConfig: AlertModal;
  public directUserModalConfig: AlertModal;
  public tooltipModalConfig: AlertModal;
  res;
  registrationDetailForm: UntypedFormGroup;
  registrationConfiguration: object;
  public countryNamesList: any;
  public otherTitleList: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  protected registerButtonConfig = this.userInputDetail.regsiterbuttonConfig;
  public genderConfig = this.userInputDetail.genderConfig;
  public maritalStatusConfig = this.userInputDetail.maritalStatusConfig;
  public fnameTextConfigtitleConfig = this.userInputDetail.titleConfig;
  public fnameTextCodeConfig = this.userInputDetail.fnameTextConfig;
  public firstNameToolTipInfoCodeConfig = this.userInputDetail.firstNameToolTipInfoConfig;
  public addressToolTipInfoCodeConfig = this.userInputDetail.addressToolTipInfoCodeConfig;
  public titleConfig = this.userInputDetail.titleConfig;
  public lnameTextCodeConfig = this.userInputDetail.lnameTextConfig;
  public middleNameTextCodeConfig = this.userInputDetail.middleNameTextConfig;
  public addressLine1CodeConfig = this.userInputDetail.addressLine1Config;
  public addressLine2CodeConfig = this.userInputDetail.addressLine2Config;
  public addressLine3CodeConfig = this.userInputDetail.addressLine3Config;
  public addressLine4CodeConfig = this.userInputDetail.addressLine4Config;
  public radioButtonIsUKAddressConfig = this.userInputDetail.radioButtonIsUKAddressConfig;
  public postCodeConfig = this.userInputDetail.postCodeConfig;
  public dobCodeConfig = this.userInputDetail.dobConfig;
  public emailTextCodeConfig = this.userInputDetail.emailTextConfig;
  public confirmEmailTextCodeConfig = this.userInputDetail.confirmEmailTextConfig;
  public mobilePhoneCodeConfig = this.userInputDetail.mobileRegistrationPhoneConfig;
  // public homePhoneCodeConfig = this.userInputDetail.homeRegistrationPhoneConfig;
  private subscripBeforeLogin: Subscription;
  cardRefreshDetail: CardRefresh;
  quoteCalculationStore: Observable<any[]>;
  cardRefreshStore: Observable<CardRefresh[]>;
  showModalForCardRefresh: boolean = false;
  cardRefresh: boolean;
  cardStoreVal: boolean;
  public alertCardRefreshModalConfig: AlertModal = new AlertModal('alert', ' You have entered new information that may impact your quote', '', 'Continue', 'Discard changes', '');

  private subscriptn: Subscription;
  private subscripSaveProgress: Subscription;
  //protected countryConfig = this.userInputDetail.countryConfig;
  public dobInformationConfig = this.userInputDetail.personalDetailDOBInformation;
  //protected regexPatterncode = this.userInputDetail.emailTextConfig.regexPattern;
  // protected emailtoolTipInfoConfig =this.userInputDetail.emailtoolTipConfig;
  QuoteAffectingValues = this.userInputDetail.QuoteAffectingValues;
  personalFormEdit: RegistrationDetails;
  ukAddressCheckFlag: boolean;
  showRegistrationAlerts: boolean;
  existingUserCheckFlag: boolean;
  nonAuthUserCheckFlag: boolean;
  authenticatedUserFlag: boolean;
  nextPath: string;
  show = false;
  hide = false;
  private subscription: Subscription;
  contentData;
  tooltipModal;
  cmsData1;
  public personalMinAge: string;
  /* protected cmsDataNew:any; */
  personDetail: PersonalDetails;
  registrationDetails: RegistrationDetails;
  personalDetailsStore: Observable<PersonalDetails[]>;
  registrationDetailsStore: Observable<RegistrationDetails[]>;
  public countryName = [];
  public otherTitle = [];
  public array1 = [];
  regRouter: string;
  isUkResident = 'Y';
  addressSeachEnabled = false;
  loadingFlag: boolean = false;
  deviceType: any;
  // personalMinAge:string;
  public dontShowMsgAgain: boolean;
  public noWarningMSg: boolean;
  public CMSData;
  public disableMarketingConsent: boolean = false;
  quoteRefNo: string;
  loginDetails: any;
  // updateMyValuesForm: FormGroup;
  proceedFlag = false;
  maritalStatsSub: any;
  maritalFlag: boolean = false;
  customerDetail: any;
  public updatedModal: AlertModal;
  dobVal;
  ukAddressIndicatiorVal: string;
  genderVal;
  serverDetail: any;
  CMSDataUpdateDetails;
  CMSDataAgeVal: any;
  isDisabledCTA: boolean = false;
  referenceNumber: RefNo;
  accessibilityTitle: string;
  accessibilityCopy: string;
  marketingPermission: string;
  displayTooltipAlert = false;
  isDateInputRequired: boolean;
  config: any;
  constructor(
    public router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private cmsService: CmsService,
    private http: HttpClient,
    private syncService: SyncService,
    private activatedRoute: ActivatedRoute,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private annuitantservice: AnnuitantDetailService,
    // tslint:disable-next-line:variable-name
    private loaderService: LoaderService, private _location: Location,
    private buttonService: ButtonService,
    public el: ElementRef,
    private store: Store<AppState>,
    private utilService: UtilService,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private analyticsService: AnalyticsService,
    private deviceDimensionsService: DeviceDimensionsService,
    private configLoaderService: ConfigLoaderService) {
    this.serverDetail = commonUserDataConfig.BreadcrumbConfig.authServer;

    this.contentData = this.route.snapshot.data.contentData.registrationDetail;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    // this.isDateInputRequired = this.route.snapshot.data.contentData.registrationDetail.isDateInputRequired;


    this.regRouter = router.url;
    this.registrationDetailsStore = store.select(STORE_VAL.registration_details);


    this.registrationDetailsStore.subscribe((val) => {
      if (val.length > 0) {

        this.registrationDetails = val[0];
        // this.userFormData();
      } else if (this.registrationDetailForm && val.length != 0) {
        this.registrationDetailForm.reset();

      }
    });

    this.personalDetailsStore = store.select(STORE_VAL.personal_details);


    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {

        this.personDetail = val[0];
        // this.userFormData();
      } else if (this.registrationDetailForm) {
        this.registrationDetailForm.reset();

      }
    });
    // login data store
    store.select(STORE_VAL.loggedin_detail).subscribe((val) => {
      if (val.length > 0) {
        this.loginDetails = val[0];
        this.customerDetail = this.loginDetails.customer;
        if(this.customerDetail && this.customerDetail.title && 
           (this.customerDetail.title == 'mr' || this.customerDetail.title == 'miss' || 
           this.customerDetail.title == 'mrs' || this.customerDetail.title == 'ms' ||
           this.customerDetail.title == 'doctor' || this.customerDetail.title == 'mx') ) {
          this.customerDetail.title = this.customerDetail.title.charAt(0).toUpperCase() + this.customerDetail.title.slice(1)
        }
      }
    });
     // card data store 
    this.quoteCalculationStore = store.select(STORE_VAL.quote_calculation);
    this.cardRefreshStore = store.select(STORE_VAL.card_Refresh);
    this.cardRefreshStore.subscribe((val) => {
      if (val) {
        this.cardStoreVal = val[0]?.['setCardRefresh'];
        // console.log("value of flag for card refresh in store", this.cardStoreVal);
      }
    });
    store.select(STORE_VAL.ref_no).subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        this.quoteRefNo = this.referenceNumber?.quoteReferenceNumber;
      }
    });
    this.cardRefresh = this.quoteDatacaptureService.isCardCreatedforRefresh(this.quoteRefNo);

    this.syncService.getRegisterBackData().subscribe(res => {
      this.disableMarketingConsent = res.disableChecbox;
    });
  
  }

  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.isDateInputRequired = this.configLoaderService.configuration.isDateInputRequired;

    this.GetCMSDataService();
    this.GetCMSDataService1();
    this.subscripBeforeLogin = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.utilService.afterSaveSuccesfully();
    });
    this.GetCMSDataServiceMapper_AgeValidation();
    // dtc-309 
    this.alertCardRefreshModalConfig.setContent(this.route.snapshot.data.contentData.generalConstants.cardRefreshWarning);
    // this.alertModalConfig.setContent(this.contentData.quoteChangeWarning);
    // this.ageAlertModalConfig.setContent(this.contentData.ageValidationWarning);
    this.ukAddressAlertModalConfig = this.contentData.ukAddressAlertModalConfig;
    this.directUserModalConfig = this.contentData.directUserModalConfig;
    this.addressSeachEnabled = true;
    if (this.loginDetails && this.registrationDetails) {
      if( this.titleConfig &&  this.titleConfig.options.length > 0 && this.customerDetail.title === 'Other') {
        if(this.titleConfig.options.filter(val => val['value'] == this.customerDetail.otherTitle).length == 1) {
          this.customerDetail.title = this.customerDetail.otherTitle;
          this.customerDetail.otherTitle = '';
        }
      }
      this.enableOtherTitle = this.customerDetail.title === 'Other' ? true : false;
      this.ukAddressIndicatiorVal = this.customerDetail.ukaddressIndicator === 'Y' ? 'Yes' : 'No';
      this.genderVal = this.customerDetail.gender === 'M' ? 'Male' : 'Female';
      // tslint:disable-next-line:max-line-length
      this.dobVal = this.customerDetail.dateOfBirth.indexOf('/') > -1 ? (this.customerDetail.dateOfBirth.split('/').join(' / ')) : this.customerDetail.dateOfBirth;
      this.getOtherTitle();
      this.setUpdatedFormData();
      this.updatedModal = this.contentData.updateNowModalConfig;
      this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
      });
      FormValidationsService.validateAllFormFields(this.registrationDetailForm, this.analyticsService);
      setTimeout(() => {
         this.scrollInvalidForm();
       }, 0);
    } else {
      this.userFormData();
      this.setMiddleNameValidators();
    }
    // this.ukaddressCheck();
    this.maritalStatsSub = this.registrationDetailForm.get('maritalStatus').valueChanges
      .pipe(
      filter(() => this.registrationDetailForm.get('maritalStatus').valid)
      )
      .subscribe(res => {
        if (this.loginDetails && res !== this.customerDetail.maritalStatus) {
          this.maritalFlag = true;
          this.showRefreshModal();
        }
      });
    if (this.isUkResident === 'Y') {
      if(this.registrationDetailForm.controls['addressline2']){
        this.registrationDetailForm.controls['addressline2'].clearValidators();
      }
    }  
    this.detectScreenSize();
  }

  @HostListener('window:resize', [])
  public onResize() {
    this.detectScreenSize();
  }
  private detectScreenSize() {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
  }
 
  userFormData = () => {
    if (this.registrationDetails && !this.checkProperties(this.registrationDetails)) {
      this.addressSeachEnabled = false;
      this.registrationDetailForm = this.fb.group({
        surname: [this.registrationDetails.surname, [Validators.required,
        Validators.pattern('^.{2,}$')]],
        forename: [this.registrationDetails.forename, [Validators.required,
        Validators.pattern('^.{2,}$')]],
        emailAddress: [this.registrationDetails.emailAddress, Validators.required],
        dateOfBirth: [this.registrationDetails.dateOfBirth, Validators.required],
        gender: [this.registrationDetails.gender, Validators.required],
        maritalStatus: [this.registrationDetails.maritalStatus, Validators.required],
        ukaddressIndicator: [this.isUkResident],
        postcode: [this.registrationDetails.postcode, Validators.required],
        userTitle: [this.registrationDetails.userTitle, Validators.required],
        otherTitle: [this.registrationDetails.otherTitle, Validators.required],
        middleName: [this.registrationDetails.middleName],
        thirdName: [this.registrationDetails.thirdName],
        addressline1: [this.registrationDetails.addressline1],
        addressline2: [this.registrationDetails.addressline2],
        addressline3: [this.registrationDetails.addressline3],
        addressline4: [this.registrationDetails.addressline4],
        homePhone: [this.registrationDetails.homePhone],
        mobilePhone: [this.registrationDetails.mobilePhone],
        // country: [null],
        confirmEmailAddress: [this.registrationDetails.confirmEmailAddress],
        internalSoftOptInInd: [this.registrationDetails.internalSoftOptInInd]
        //country: [this.personDetail.country]
      },
        {
          validator: EmailMatch('emailAddress', 'confirmEmailAddress')
        });

    }
    else if (this.personDetail && !this.checkProperties(this.personDetail)) {
      this.registrationDetailForm = this.fb.group({
        surname: [this.personDetail.surname, [Validators.required,
        Validators.pattern('^.{2,}$')]],
        forename: [this.personDetail.forename, [Validators.required,
        Validators.pattern('^.{2,}$')]],
        dateOfBirth: [this.personDetail.dateOfBirth, Validators.required],
        gender: [this.personDetail.gender, Validators.required],
        maritalStatus: [this.personDetail.maritalStatus, Validators.required],
        ukaddressIndicator: [this.isUkResident],
        postcode: [this.personDetail.postcode, Validators.required],
        userTitle: [null, Validators.required],
        otherTitle: [null, Validators.required],
        middleName: [''],
        thirdName: [''],
        emailAddress: ['', Validators.required],
        addressline1: ['', Validators.required],
        addressline2: [''],
        addressline3: [''],
        addressline4: [''],
        homePhone: [''],
        mobilePhone: [''],
        confirmEmailAddress: ['', Validators.required],
        internalSoftOptInInd: ['']
        //country: [this.personDetail.country]
      },
        {
          validator: EmailMatch('emailAddress', 'confirmEmailAddress')
        });
    } else {
      this.registrationDetailForm = this.fb.group({
        userTitle: [null, Validators.required],
        otherTitle: [null],
        forename: ['', [Validators.required,
        Validators.pattern('^.{2,}$')]],
        middleName: [''],
        surname: ['', [Validators.required,
        Validators.pattern('^.{2,}$')]],
        thirdName: [''],
        emailAddress: ['', Validators.required],
        dateOfBirth: ['', Validators.required],
        gender: [null, Validators.required],
        maritalStatus: [null, Validators.required],
        ukaddressIndicator: [this.isUkResident],
        postcode: ['', Validators.required],
        addressline1: ['', Validators.required],
        addressline2: ['', Validators.required],
        addressline3: [''],
        addressline4: [''],
        homePhone: [''],
        mobilePhone: [''],
        country: [null],
        confirmEmailAddress: ['', Validators.required],
        internalSoftOptInInd: ['']
      },
      
        {
          validator: EmailMatch('emailAddress', 'confirmEmailAddress')
        });
    }
    if (this.registrationDetailForm.get('userTitle').value !== 'Other') {
      const othTitle = this.registrationDetailForm.get('otherTitle');
      othTitle.setValidators(null);
      this.registrationDetailForm.updateValueAndValidity();

     }
  }
  // dtc-309 udpated form details
  setUpdatedFormData = () => {
    this.registerButtonConfig.label = 'Update now';
    this.registrationDetailForm = this.fb.group({
      userTitle: [this.customerDetail.title, Validators.required],
      otherTitle: [this.customerDetail.otherTitle],
      emailAddress: [this.customerDetail.emailAddress, Validators.required],
      confirmEmailAddress: [this.customerDetail.emailAddress, Validators.required],
      maritalStatus: [this.customerDetail.maritalStatus, Validators.required],
      // homePhone: [this.customerDetail.homePhone],
      mobilePhone: [this.customerDetail.mobilePhone],
      internalSoftOptInInd: [this.customerDetail.internalSoftOptInInd]
    },
      {
        validator: EmailMatch('emailAddress', 'confirmEmailAddress')
      });
  }
  // method to save the updated form details
  saveProgress() {
    this.saveUpdatedDetailsToStore();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {

    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }

    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
  }
  getOtherTitle() {
    this.annuitantservice.getOtherTitle().subscribe(data => {
      this.otherTitleList = data;
    });
    this.otherTitle = this.array1;
  }

  OnBackClick() {
    // adding form to store

    this.store.dispatch(new RegsDetailsActions.RemoveRegistrationDetails(0));
    this.store.dispatch(new RegsDetailsActions.AddRegistrationDetails(this.registrationDetailForm.value));
  }


  createAccount() {
    let formchanged = false;
    if (this.registrationDetailForm.valid) {

      // this.buttonService.handleButtonLoaderFlag({ flag: true });
      this.loadingFlag = true;
      this.store.dispatch(new RegsDetailsActions.RemoveRegistrationDetails(0));
      this.store.dispatch(new RegsDetailsActions.AddRegistrationDetails(this.registrationDetailForm.value));
      // if uk indicatior is not uk then call savequote
      if (!this.loginDetails && this.registrationDetailForm.get('ukaddressIndicator').value !== 'Y') {
        this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          // this.router.navigate(['/home/your-personal-details']);
          this.loadingFlag = false;
          this.ukAddressCheckFlag = true;

          this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
          this.store.dispatch(new PersDetailsActions.AddPersonalDetails({
            contactNumber: res['customer'] ? res['customer'].contactNumber : '',
            dateOfBirth: res['customer'].dateOfBirth ? res['customer'].dateOfBirth.split('/').join(' / ') : null,
            emailAddress: res['customer'] ? res['customer'].emailAddress : '',
            forename: res['customer'].forename,
            gender: res['customer'].gender,
            maritalStatus: res['customer'].maritalStatus,
            postcode: res['customer']['address'].postcode,
            surname: res['customer'].surname,
            ukaddressIndicator: res['customer'].ukaddressIndicator,
            consentDate: res.customer.consentDate,
            consentIndicator: res.customer.consentIndicator,
            pwAppointmentdate: res.customer.pwAppointmentdate,
            customerCareInfo: res.customer.customerCareInfo
          }));
          this.analytics(res['customer']);
        });
      } else if (this.loginDetails && (this.loginDetails.customer.registrationStatus || this.loginDetails.customer.reviewStatus)) { // dtc-309 updatedRegistration logic
        if (!this.loginDetails.customer.registrationStatus && this.loginDetails.customer.reviewStatus){
          // If the user is not registered but navigating from review page
          this.saveRegUpdatedDetailsToStore();
          this.loginDetails = {...this.loginDetails, customer: {...this.loginDetails.customer, reviewStatus: true}};
        } else {
          // If the user is registered
          this.saveUpdatedDetailsToStore();
        }
        
        this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: true, Message: '', opacity: .4 });
        
        this.quoteDatacaptureService.updateRegisteredDetailsDataCapture(true).subscribe(res => {
          this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
          // this.buttonService.handleButtonLoaderFlag({ flag: false });
          if (res.updateStatus) {
            // this.loginDetails.customer.title = res['title'] ? res['title'] : '';
            this.loginDetails = {...this.loginDetails, customer: {...this.loginDetails.customer, title: res['title'] ? res['title'] : ''}};
            this.loginDetails.customer.maritalStatus = res['maritalStatus'] ? res['maritalStatus'] : '';
            this.loginDetails.customer.emailAddress = res['emailAddress'] ? res['emailAddress'] : '';
            this.loginDetails.customer.mobilePhone = res['mobilePhone'] ? res['mobilePhone'] : '';
            this.loginDetails.customer.homePhone = res['homePhone'] ? res['homePhone'] : '';
            this.loginDetails.customer.internalSoftOptInInd = res['internalSoftOptInInd'] ? res['internalSoftOptInInd'] : '';

            this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
            this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(this.loginDetails));
            this.loadingFlag = false;
            const response = res.status;
            this.proceedFlag = true;
          }
          this.analytics(res);
        });
         // this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
         // this.loadingFlag = false;
         // this.proceedFlag = true;
      } else {
          this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: true, Message: '', opacity: .4 });
          this.quoteDatacaptureService.postRegistrationDataCapture(true).subscribe(res => {
          this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
          this.loadingFlag = false;
          const response = res.status;
          this.analytics(this.registrationDetailForm.value)
          // Registration success
          this.showRegistrationAlerts = true;
          if(res.status === ATTRIBUTE_NAMES_CONST.success){
            this.authenticatedUserFlag = false;
            if(!res.updateDetailsToGCD) {
              // User exists and Non Authenticated
              this.existingUserCheckFlag = true;
              this.nonAuthUserCheckFlag = true;
              this.nextPath = 'back_to_landing_page';
              this.contentData.directUserModalConfig.header = this.CMSData.string_welcomeback;
              this.contentData.directUserModalConfig.content = this.CMSData.string_Completeyourregistration;
              this.displayNextButton(ATTRIBUTE_NAMES_CONST.back_to_landing);
              this.analyticsService.eventTrack({type: 'Lightbox', name: 'Existing user - non-authenticated', position: 'Registration'});
            }else{
              // New User
              this.existingUserCheckFlag = false;
              this.contentData.directUserModalConfig.header = this.CMSData.string_savingyourdetails;
              this.contentData.directUserModalConfig.content = this.CMSData.string_emailwithregistration;
              this.nextPath = 'proceed_to_quote';
              this.displayNextButton(ATTRIBUTE_NAMES_CONST.continue_to_quote);
              this.saveRegUpdatedDetailsToStore(res);
              this.analyticsService.eventTrack({type: 'Lightbox', name: 'New users - email sent', position: 'Registration'});
              this.analyticsService.customerStatusTrack({status: res.status, updateDetailsToGCD: res.updateDetailsToGCD});
            }
          } else if(res.status === ATTRIBUTE_NAMES_CONST.registered) {
            // Registered User
            this.authenticatedUserFlag = true;
            this.nextPath = 'login';
            this.contentData.directUserModalConfig.header = this.CMSData.string_welcomeback;
            this.contentData.directUserModalConfig.content = this.CMSData.string_Resetyourpassword;
            this.displayNextButton(ATTRIBUTE_NAMES_CONST.login);
            this.analyticsService.eventTrack({type: 'Lightbox', name: 'Existing user - previously authenticated', position: 'Registration'});
          } else {
            this.existingUserCheckFlag = true;
            this.nextPath = 'back_to_landing_page';
            this.contentData.directUserModalConfig.header = this.CMSData.String_problemmessage;
            this.contentData.directUserModalConfig.content = this.CMSData.String_contactuswording;
            this.displayNextButton('Back');
            this.analyticsService.eventTrack({type: 'Lightbox', name: 'Request Failure', position: 'Registration'});
          }
        });
      }
    }

    else {
      FormValidationsService.validateAllFormFields(this.registrationDetailForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }



    //this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: true, Message: '', opacity: .4 });
    /*  setTimeout(() =>{  
     this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
     this.buttonService.handleButtonLoaderFlag({ flag: false });

     this.loadingFlag = false;
  },5000);  */


    /* this.quoteDatacaptureService.postRegistrationCapture(true).subscribe(res => {
      // this.router.navigate(['/home/beforestart']);
    }); */
  }

  displayTooltipMessage(el){
    let config;
    
    switch(el) {
      case "firstname":
        config = this.firstNameToolTipInfoCodeConfig;
        break;
      case "dob":
        config = this.dobInformationConfig;
        break;
      case "citizen":
        config = this.userInputDetail.radioButtonIsUKAddressConfig.infoIconData;
        break;    
    }
    this.tooltipModal.content = config.content;
    this.displayTooltipAlert = true;
  }


  displayNextButton(buttonLabel) {
    this.contentData.directUserModalConfig.footerPrimaryBtnLabel = buttonLabel;
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
// save updated data to registration and login store
  saveUpdatedDetailsToStore() {
    let customer: any;
    customer = {
      userTitle: this.registrationDetailForm.value.userTitle,
      otherTitle: this.registrationDetailForm.value.otherTitle ? this.registrationDetailForm.value.otherTitle : null,
      forename: this.customerDetail.forename,
      surname: this.customerDetail.surname,
      middleName: this.customerDetail.middleName,
      thirdName: this.customerDetail.thirdName,
      dateOfBirth: this.customerDetail.dateOfBirth,
      customerId: this.customerDetail.customerId ? this.customerDetail.customerId : null,
      emailAddress: this.registrationDetailForm.value.emailAddress,
      confirmEmailAddress: this.registrationDetailForm.value.confirmEmailAddress,
      maritalStatus: this.registrationDetailForm.value.maritalStatus,
      gender: this.customerDetail.gender,
      ukaddressIndicator: this.customerDetail.ukaddressIndicator,
      address: {
        line1: this.customerDetail.address.line1,
        line2: this.customerDetail.address.line2,
        line3: this.customerDetail.address.line3,
        line4: this.customerDetail.address.line4,
        postcode: this.customerDetail.address.postcode,
      },
      homePhone: this.registrationDetailForm.value.homePhone,
      mobilePhone: this.registrationDetailForm.value.mobilePhone,
      partyId: this.customerDetail.partyId,
      internalSoftOptInInd: this.customerDetail.internalSoftOptInInd,
      registrationStatus: true,
    };
    this.loginDetails = {...this.loginDetails, customer: customer};
    this.loginDetails.customer['title'] = customer.userTitle;
    this.store.dispatch(new RegsDetailsActions.RemoveRegistrationDetails(0));
    this.store.dispatch(new RegsDetailsActions.AddRegistrationDetails(customer));
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(this.loginDetails));
  }
  
  saveRegUpdatedDetailsToStore(response?: any) {
    let customer: any;
    customer = {
      userTitle: this.registrationDetails.userTitle,
      otherTitle: this.registrationDetails.otherTitle ? this.registrationDetails.otherTitle : null,
      forename: this.registrationDetails.forename,
      surname: this.registrationDetails.surname,
      middleName: this.registrationDetails.middleName,
      thirdName: this.registrationDetails.thirdName,
      dateOfBirth: this.registrationDetails.dateOfBirth,
      emailAddress: this.registrationDetails.emailAddress,
      confirmEmailAddress: this.registrationDetails.confirmEmailAddress,
      maritalStatus: this.registrationDetails.maritalStatus,
      gender: this.registrationDetails.gender,
      ukaddressIndicator: this.registrationDetails.ukaddressIndicator,
      address: {
        line1: this.registrationDetails.addressline1,
        line2: this.registrationDetails.addressline2,
        line3: this.registrationDetails.addressline3,
        line4: this.registrationDetails.addressline4,
        postcode: this.registrationDetails.postcode,
      },
      homePhone: this.registrationDetails.homePhone,
      mobilePhone: this.registrationDetails.mobilePhone,
      partyId: response && response.partyId ? response.partyId : "",
      internalSoftOptInInd: this.registrationDetails.internalSoftOptInInd,
      registrationStatus: false,
      status: response ? response.status : "Success",
      updateDetailsToGCD: response ? response.updateDetailsToGCD : true
    };
    this.loginDetails = {...this.loginDetails, customer: customer};
    this.loginDetails.customer['title'] = customer.userTitle;
    this.store.dispatch(new RegsDetailsActions.RemoveRegistrationDetails(0));
    this.store.dispatch(new RegsDetailsActions.AddRegistrationDetails(customer));
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(this.loginDetails));
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.loginDetails));
  }

  toggleFlag() {
    this.addressFlag = !this.addressFlag;
  }

  checkDataChange = (flagArray) => {
    if (flagArray[0] === true) {
      this.ageValidatorFlag = true;
    }
  }

  checkMarketingConsent(selectedValue: boolean, id: string) {
    if(selectedValue === true) {
      this.registrationDetailForm.get(id).setValue('N');
    } else {
      this.registrationDetailForm.get(id).setValue('Y');
    }
  }

  isChecked(): boolean {
    let chk;
    ////console.log("Is CHaked=>",this.registrationDetailForm.get('marketing.email').value);
    if(this.registrationDetailForm.get('internalSoftOptInInd').value && this.registrationDetailForm.get('internalSoftOptInInd').value === 'N'){
      chk = true;
    } else {
      chk = false;
    }
    return chk;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }

  alertAgePrimaryBtnClick() {
    this.closeAgeModal();
  }
  alertUkAddressPrimaryBtnClick() {
    //this.router.navigate([this.quoteDatacaptureService.screenName]);
    this._location.back();
  }
  alertAuthUserPrimaryBtnClick(nextPath) {
    if(nextPath === "login") {
      this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Proceed to quote', pageID: 'Register'});
      this.utilService.loginDetails();
    } else if(nextPath === "proceed_to_quote") {
      this.router.navigate(['/home/guidance-and-advice']);
    } else {
      this.router.navigate(['/home/get-your-online-quote']);
    }
  }
  alertAuthUserSecondaryBtnClick() {
    this.closeAuthUserModal();
  }
  closeModal() {
    this.displayAlert = false;
  }

  closeTooltipModal() {
    this.displayTooltipAlert = false;
  }

  closeAgeModal() {
    this.ageValidatorFlag = false;
  }
  closeUkAddressModal() {
    this.ukAddressCheckFlag = false;
    this.noWarningMSg = (this.dontShowMsgAgain === true ? true : false);
  }
  closeAuthUserModal(nextPath?: string){
    this.showRegistrationAlerts = false;
    if(nextPath === "proceed_to_quote") {
      this.router.navigate(['/home/guidance-and-advice']);
    } else {
      this.closeAuthUserModal();
    }
  }
  dontShowUPMsgAgain(val) {
    this.dontShowMsgAgain = val;
  }
  toggleContainer = (data) => {

    if (data === 'Y') {
      this.isDisabledCTA = false;
      this.ukAddressCheckFlag = false;
      this.registrationDetailForm.get('ukaddressIndicator').setValue('Y');
      this.registrationDetailForm.controls['postcode'].setValidators([Validators.required]);
      this.overseasCustomer = false;
      this.addressSeachEnabled = true;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.registrationDetailForm.controls['addressline2'].clearValidators();
      this.addressLine2CodeConfig.required = false;
      } else {
      this.isDisabledCTA = true;
      this.ukAddressCheckFlag = true;
      this.registrationDetailForm.get('ukaddressIndicator').setValue('N');
      // remove validation
      this.registrationDetailForm.controls['postcode'].clearValidators();
      this.registrationDetailForm.get('postcode').setValue('');
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.registrationDetailForm.controls['addressline2'].setValidators(Validators.required);
      this.addressLine2CodeConfig.required = true;
      this.overseasCustomer = true;
      this.addressSeachEnabled = false;
    }
    if (this.editMode) {
      this.showChangeAlert();
    }

  }

  toggleMPConsent = (data) => {
    if (data === 'Y') {
      this.registrationDetailForm.get('ukaddressIndicator').setValue('Y');
    } else {
      this.registrationDetailForm.get('ukaddressIndicator').setValue('N');
    }
  }

  showChangeAlert = () => {
    //if (this.annuitantDetailForm.valid) {
    let formchanged = false;
    if (this.editMode) {

      for (let val of this.QuoteAffectingValues.personalDetail) {
        if (this.registrationDetailForm.controls[val].value !== this.personalFormEdit[val]) {

          this.personalFormEdit[val] = this.registrationDetailForm.controls[val].value;
          if (val !== 'ukaddressIndicator') {
            formchanged = true;
          }
          // break;
        }
      }
      if (formchanged) {
        this.displayAlert = true;
      } else {
      }
    }
  }
  // ukaddressIndicatorCheck() {
  //   if (this.registrationDetailForm.controls['ukaddressIndicator'].value === 'N') {
  //     this.ukAddressCheckFlag = true;
  //   } else {
  //     this.ukAddressCheckFlag = false;
  //   }
  // }

  onManualClick() {
    this.addressSeachEnabled = !this.addressSeachEnabled;
  }
  onAddressSeachClick() {
    this.addressSeachEnabled = !this.addressSeachEnabled;
  }
  onSelecteAddress(formattedAddress) {
    this.addressLine1CodeConfig.value = formattedAddress[0]['addressLine1'];
    this.addressLine2CodeConfig.value = formattedAddress[1]['addressLine2'];
    this.addressLine3CodeConfig.value = formattedAddress[2]['addressLine3'];
    this.postCodeConfig.defaultValue = formattedAddress[5]['postalCode'];
    this.addressLine4CodeConfig.value = formattedAddress[3]['locality'];
    this.addressSeachEnabled = false;
  }


  txtChange = () => {
    this.showChangeAlert();
  }


  triggerotherTitleValidation() {
    this.registrationDetailForm.updateValueAndValidity();
  }

  detectChange() {
    //const otherTitleControlname = this.registrationDetailForm.get('otherTitle');
    const othTitle = this.registrationDetailForm.get('otherTitle');
    if (this.titleConfig.defaultValue === 'Other') {
      this.enableOtherTitle = true;
      othTitle.setValidators(Validators.required);
      this.getOtherTitle();
    } else {
      this.registrationDetailForm.controls['otherTitle'].setValue(null);
      this.enableOtherTitle = false;
      othTitle.setValidators(null);
      // this.otherTitle=null;
    }
    this.triggerotherTitleValidation();

  }

  backtoPrevious() {

    // this.closeModal();
   // this.store.dispatch(new RegsDetailsActions.RemoveRegistrationDetails(0));
    //this.store.dispatch(new RegsDetailsActions.AddRegistrationDetails(this.registrationDetailForm.value));
    if (this.loginDetails) {
      if (!this.customerDetail.maritalStatus || this.customerDetail.maritalStatus.length <= 0) {
       // this.registrationDetailForm.get('maritalStatus').markAsTouched();
       // this.registrationDetailForm.get('maritalStatus').setErrors({required: true });
       FormValidationsService.validateAllFormFields(this.registrationDetailForm, this.analyticsService);
       setTimeout(() => {
         this.scrollInvalidForm();
       }, 0);
       return;
      }
      // tslint:disable-next-line: max-line-length
      if (this.applicationDatacaptureService.applicationDataCapture && this.applicationDatacaptureService.applicationDataCapture.currentScreen){
        this.router.navigate([this.utilService.getScreenName(this.applicationDatacaptureService.applicationDataCapture.currentScreen)]);
        } else if (this.quoteDatacaptureService.quoteDataCapture && this.quoteDatacaptureService.quoteDataCapture.currentScreen){
      this.router.navigate([this.utilService.getScreenName(this.quoteDatacaptureService.quoteDataCapture.currentScreen)]);
      } else {
        this._location.back();
      }
    } else {
     /* if (this.applicationDatacaptureService && this.applicationDatacaptureService.screenName !== '') {
        this.router.navigate([this.utilService.getScreenName(this.applicationDatacaptureService.screenName)]);
      } else
      */
      if (this.quoteDatacaptureService && this.quoteDatacaptureService.screenName !== '') {
        this.router.navigate([this.utilService.getScreenName(this.quoteDatacaptureService.screenName)]);
      } else if (this.applicationDatacaptureService && this.applicationDatacaptureService.screenName !== '') {
        this.router.navigate([this.utilService.getScreenName(this.applicationDatacaptureService.screenName)]);
      } else {
        this.router.navigate(['/home/get-your-online-quote']);
      }
    }
    // this._location.back();
  }

  setMiddleNameValidators() {
    const middleNameControl = this.registrationDetailForm.get('middleName');
    const thirdNameControl = this.registrationDetailForm.get('thirdName');

    thirdNameControl.valueChanges
      .subscribe(thirdName => {

        if (thirdName !== '' && thirdNameControl.dirty
          && (!middleNameControl.value || middleNameControl.value === '')) {
          // middleNameControl.setValidators(null);
          // middleNameControl.setValidators([Validators.required]);
          middleNameControl.setErrors({ required: true });


        } else if (!middleNameControl.hasError('notValidname')) {
          middleNameControl.setErrors(null);
          // middleNameControl.setValidators(null);
        }
        // middleNameControl.updateValueAndValidity();

      });

    middleNameControl.valueChanges
      .subscribe(middleName => {
        if (middleName === '' &&
          thirdNameControl.value !== '' &&
          thirdNameControl.dirty) {
          middleNameControl.setErrors({ required: true });
        } else if (!middleNameControl.hasError('notValidname')) {
          middleNameControl.setErrors(null);
        }

      });
  }
  // redirects to the screen where user selected "update my details"
  proceedClick() {
    this.proceedFlag = false;
    // tslint:disable-next-line: max-line-length
    if (this.applicationDatacaptureService.applicationDataCapture && this.applicationDatacaptureService.applicationDataCapture.currentScreen){
      this.router.navigate([this.utilService.getScreenName(this.applicationDatacaptureService.applicationDataCapture.currentScreen)]);
    } else if (this.quoteDatacaptureService.quoteDataCapture && this.quoteDatacaptureService.quoteDataCapture.currentScreen){
    this.router.navigate([this.utilService.getScreenName(this.quoteDatacaptureService.quoteDataCapture.currentScreen)]);
    } else {
      this._location.back();
    }
    /*
    if (this.quoteDatacaptureService.quoteDataCapture && this.quoteDatacaptureService.quoteDataCapture.currentScreen === 'your-product-quote'){
      this.router.navigate(['/quote/your-product-quote']);
    } else {
      this._location.back();
    }
    */
  }
  // closes the modal
  closeModal_Updated() {
    this.proceedFlag = false;
  }
  // update password
  updatePassword() {
    if (CURRENT_ENVIROMENT.environment !== 'localEnvironment') {
      // tslint:disable-next-line: max-line-length
      let serverName = '';
      if (document.location.href.toString().toUpperCase().includes('LOCALHOST')) {
        serverName = 'localhost';
      } else {
        if ( document.location.href.indexOf('lgnet') > -1) {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('lgnet') - 1);
        } else {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('landg') - 1);

        }
      }
      const configServername = this.serverDetail.find(s => s.serverName === serverName);
      // tslint:disable-next-line: max-line-length
      this.quoteDatacaptureService.resetPasswordRedirect(`${configServername.resetPasswordURL}/SAuthGateWeb/passwordReset.html?domain=dcj`);
    } else {
      if(this.CMSDataUpdateDetails) {
         // 'https://wwwpp10.landg.com/SAuthGateWeb/passwordReset.html?domain=%3Fapp '
        window.open(this.CMSDataUpdateDetails.externalUrl_ChangePassword, '_blank');
      }
    }
  }
  // refereshes card created on change maritalstatus value
  showRefreshModal() {
    if (this.cardRefresh && this.cardStoreVal && this.showModalForCardRefresh === false) {
      this.showModalForCardRefresh = true;
    }
  }
  // navigates to product-options screen after maritalStatus value changes
  alertPrimaryBtnClickinModal() {
    this.quoteDatacaptureService.postRefreshCard().subscribe(res => {
     // this.router.navigate(['/quote/your-product-options']);
    //console.log('card refresh');
   
    });
    this.store.dispatch(new CardRefreshActions.RemoveCardRefreshval(0));
    this.store.dispatch(new CardRefreshActions.AddCardRefreshval({ setCardRefresh: false }));
    this.showModalForCardRefresh = false;
  }
  /** Code block for CMS */
GetCMSDataService() {
  //console.log('original value = ', this.confirmEmailTextCodeConfig.misMatchErrorMessage);
  const URL =  SERVICE_END_POINT.higherEnvironment.CMS_Registration;
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSData = res;
    if (this.CMSData) {
    /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.header = this.CMSData.string_RegistrationTitle;
      this.contentData.introduction = this.CMSData.string_RegistrationSubtitle;
      this.contentData.marketingConsentDesc = this.CMSData.string_OptInMessage;
      this.contentData.marketingConsentText = this.CMSData.string_OptInQuestion;
      this.contentData.privacyPolicy = this.CMSData.commonBlock.string_PrivacyWording;
      this.contentData.privacyPolicyLink = this.CMSData.commonBlock.externalUrl_PrivacyPolicy;
      this.contentData.privacyPolicyText = this.CMSData.commonBlock.string_PrivacyPolicyLinkText;
      this.titleConfig.errorMessage = this.CMSData.commonBlock.string_TitleErrorMessageWording;
      this.fnameTextCodeConfig.errorMessageInvalid = this.CMSData.commonBlock.string_ValidFirstNameErrorMessageWording;
      this.lnameTextCodeConfig.errorMessageInvalid = this.CMSData.commonBlock.string_ValidSurnameErrorMessageWording;
      this.middleNameTextCodeConfig.errorMessageInvalid = this.CMSData.commonBlock.string_ValidSecondNameErrorMessageWording;
      // this.thirdNameTextCodeConfig.errorMessageInvalid = this.CMSData.commonBlock.string_ValidThirdNameErrorMessageWording;
      this.lnameTextCodeConfig.errorMessage = this.CMSData.commonBlock.string_SurnameErrorMessageWording;
      this.fnameTextCodeConfig.errorMessage = this.CMSData.commonBlock.string_FirstNameErrorMessageWording;
      this.mobilePhoneCodeConfig.invalidErrorMessage = this.CMSData.commonBlock.string_PhoneFormatError;
      // this.homePhoneCodeConfig.invalidErrorMessage = this.CMSData.commonBlock.string_PhoneFormatError;
      this.confirmEmailTextCodeConfig.misMatchErrorMessage = this.CMSData.string_ConfirmationEmailErrorMessageWording;
      this.contentData.addManually = this.CMSData.commonBlock.string_ManualAddressLinkText;
      this.userInputDetail.radioButtonIsUKAddressConfig.infoIconData.content = this.CMSData.string_UkResidentInformationWording;
      this.dobInformationConfig.content = this.CMSData.commonBlock.string_DOBInformationWording;

      this.dobCodeConfig.errorMessage = this.CMSData.commonBlock.string_DobErrorMessageWording;
      this.dobCodeConfig.errorMessageInvalidDate = this.CMSData.commonBlock.string_ValidDobErrorMessageWording;
      this.postCodeConfig.errorMessage = this.CMSData.commonBlock.string_PostcodeErrorMessageWording;
      this.mobilePhoneCodeConfig.errorMessage = this.CMSData.commonBlock.string_MobilePhoneNoErrorMessageWording;
      this.emailTextCodeConfig.errorMessage = this.CMSData.commonBlock.string_EmailErrorMessageWording;
      this.emailTextCodeConfig.invalidErrorMessage = this.CMSData.commonBlock.string_EmailErrorMessageWording;
      this.confirmEmailTextCodeConfig.invalidErrorMessage = this.CMSData.string_ConfirmationEmailErrorMessageWording;
      this.confirmEmailTextCodeConfig.errorMessage = this.CMSData.string_ConfirmationEmailErrorMessageWording2;
      // this.homePhoneCodeConfig.errorMessage = this.CMSData.commonBlock.string_HomePhoneNoErrorMessageWording;

      this.genderConfig.errorMessage = this.CMSData.commonBlock.string_GenderErrorMessage;
      this.postCodeConfig.errorMessageInvalid = this.CMSData.commonBlock.string_ValidPostcodeErrorMessageWording;
      this.maritalStatusConfig.errorMessage = this.CMSData.commonBlock.string_MaritalStatusErrorMessage;
      this.contentData.ukAddressAlertModalConfig.header = this.CMSData.string_RegistrationOverseasPopUpTitle;
      this.contentData.ukAddressAlertModalConfig.content = "";
      this.contentData.ukAddressAlertModalConfig.footerPrimaryBtnLabel = this.CMSData.string_ProceedCTALabel ? this.CMSData.string_ProceedCTALabel : "Proceed";
      this.contentData.anotherAddress = this.CMSData.commonBlock.string_ManualAddress;
      this.userInputDetail['buttonConfig'].label = this.CMSData.string_RegisterNowCTALabel;
      // tslint:disable-next-line:max-line-length
      this.alertModalConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');
      this.accessibilityTitle = this.CMSData.string_Accessibilitytitle;
      this.accessibilityCopy = this.CMSData.string_Accessibilitycopy.replaceAll('<a','<a class="a-color"');
      this.marketingPermission = this.CMSData.String_marketing_permission;
      //console.log('changed value = ', this.confirmEmailTextCodeConfig.misMatchErrorMessage);
      }
  });
}

GetCMSDataService1() {
  //console.log('original value = ');
  const URL =  SERVICE_END_POINT.higherEnvironment.CMS_UpdateMyDetails;
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSDataUpdateDetails = res;
    if (this.CMSDataUpdateDetails) {
    /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.updateHeadingText = this.CMSDataUpdateDetails.string_UpdateMyDetailsTitle;
      this.contentData.subHeading = this.CMSDataUpdateDetails.string_UpdateMyDetailsSubtitle;
      this.contentData.updatePwd = this.CMSDataUpdateDetails.string_ChangePasswordLinkText;
      this.contentData.updateNowModalConfig.header = this.CMSDataUpdateDetails.string_DetailsUpdatedTitle;
      this.contentData.updateNowModalConfig.content = this.CMSDataUpdateDetails.string_DetailsUpdated;
      this.contentData.updateNowModalConfig.footerPrimaryBtnLabel = this.CMSDataUpdateDetails.string_OkCTALabel;
      this.userInputDetail['buttonConfig'].label = this.CMSDataUpdateDetails.string_UpdateNowCTALabel;
      this.contentData.messageBox = this.CMSDataUpdateDetails.stringGroup_ContentReadOnlyMessage;

      //console.log('changed value = ');
      }
  });
}

GetCMSDataServiceMapper_AgeValidation() {
  const URL1 = SERVICE_END_POINT.higherEnvironment.CMS_AgeValidation;
  this.utilService.getCMSData(URL1).subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSDataAgeVal = res;
    if (this.CMSDataAgeVal) {
      // tslint:disable-next-line:max-line-length
      this.ageAlertModalConfig = new AlertModal('alert', this.CMSDataAgeVal.string_AgeVaidationPopUpMessageTitle , this.CMSData.commonBlock.string_DOBInformationWording, this.CMSData.commonBlock.string_OKCTALabel, '', '');
      }
  });
}
/** End of code block for CMS */


  // discards the change made to maritalstatus field
  closeCardRefreshModal() {
    if (this.maritalFlag) {
      this.registrationDetailForm.get('maritalStatus').setValue(this.customerDetail.maritalStatus);
    }
    this.showModalForCardRefresh = false;
  }
  alertSecondaryCardRefreshBtnClick() {
    if (this.maritalFlag) {
      this.registrationDetailForm.get('maritalStatus').setValue(this.customerDetail.maritalStatus);
    }
    this.showModalForCardRefresh = false;
  }

  analytics(formData) {
    let customerAge =  (formData.dateOfBirth !='' &&  formData.dateOfBirth !=null) ? formData.dateOfBirth : '' ;
         let totalAge;
         if(customerAge) {
           totalAge  = (new Date().getFullYear()) - (Number(customerAge.split('/')[2].trim()))
         }
    let personData =  { 
      'age': (totalAge) ? totalAge : '',
      'dateOfBirth': (formData.dateOfBirth) ? (formData.dateOfBirth).replaceAll('/','-') : formData.dateOfBirth, 
      'gender': (formData.gender && formData.gender == 'M') ? 'Male': 'Female', 
      'postcode': formData.postcode, 
      'email': formData.emailAddress,
      'forename': formData.forename,
      'surname': formData.surname,
      'mobilePhone': formData.mobilePhone,
      'homePhone': formData.homePhone,
      'quoteEmail': (formData.internalSoftOptInInd == 'N') ? 'N' : 'Y'

     }
     this.analyticsService.customerTrack({ ...personData});  
  }
}
